import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { aridBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Ashlands / Smoldering Wastes — a gray dead ashland: a wan ashen sky under a cold pale dead sun,
 *  dying ember glints, thin wan light-shafts, a dim breathing ember-bed at the floor, a desolate
 *  gray light bed, slow drifting ash flakes on a faint wind, guttering floor embers, skeletal black
 *  tree/ruin silhouettes, low gray smoke haze, and a DESATURATED gray grade. Bleak + post-apocalyptic —
 *  distinct from volcanic (hot/red heat) and corrupted (saturated dread-violet): here all colour is
 *  drained to gray, only a few dim embers survive. Contrast kept (no pale wash). */
export const ASHLANDS = aridBiome({
  id: 'ashlands',
  sky: { from: 0x222120, to: 0x4a443e },
  celestial: { atX: 0.68, atY: 0.18, color: 0xc4bdb2, haloColor: 0xa89f92, size: 84, haloScale: 2.8, coreAlpha: 0.5, haloAlpha: 0.12 },
  motes: { colors: [0xa6643c, 0x8a6a4a, 0x7d756a], count: 20, driftPx: 34, periodMinMs: 5500, periodMaxMs: 12000, alphaMin: 0.1, alphaMax: 0.42 },
  rays: { color: P.bone, count: 3, widthMin: 55, widthMax: 130, height: 500, tiltDeg: 6, periodMinMs: 7000, periodMaxMs: 13000, alphaMin: 0.06, alphaMax: 0.22 },
  glow: {
    blobs: [
      { color: 0x6e4830, atX: 0.5, atY: 0.96, size: 540, alpha: 0.1 },
      { color: 0x55504a, atX: 0.5, atY: 0.1, size: 400, alpha: 0.06 },
    ],
    breathe: { periodMs: 5600, min: 0.7, max: 1.3 },
  },
  lightField: { palette: [0x6e665c, 0x4a443e, 0x8a6a4a], sizeMin: 110, sizeMax: 280, driftRadius: 65, periodMinMs: 6000, periodMaxMs: 12000 },
  weather: { mode: 'fall', color: 0x9a948a, colorEnd: 0x55504a,
    frequencyMs: 110, lifespanMs: 5200, speed: 12, gravityY: 4, windX: 20,
    gust: { periodMs: 8000, min: 0.5, max: 1.4, phase: 0.3 } },
  flicker: { color: 0x9a5a30, size: 260, hzMax: 6, anchors: [{ atX: 0.2, atY: 0.9 }, { atX: 0.5, atY: 0.95 }, { atX: 0.8, atY: 0.9 }] },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.volcanic.far, shape: 'spires', color: 0x2a2724, speed: 0.04, height: 420, alpha: 0.7, detail: 0.9, sway: { ampPx: 10, periodMs: 26000 } },
    { svg: OTHERWORLD_BACKDROPS.volcanic.mid, shape: 'columns', color: 0x1d1b18, speed: 0.1, height: 300, alpha: 0.85, detail: 1.1 },
    { svg: OTHERWORLD_BACKDROPS.volcanic.near, shape: 'spires', color: 0x110f0d, speed: 0.19, height: 185, alpha: 0.95, detail: 1 },
  ],
  fog: { color: 0x6e665c, bands: 5, alphaMin: 0.04, alphaMax: 0.12, driftPx: 50, periodMinMs: 9000, periodMaxMs: 16000 },
  closer: {
    vignette: { color: 0x161412, edgeAlpha: 0.36, washColor: 0x6e665c, washAlpha: 0.05 },
    grade: { top: 0x9a948a, bottom: 0x33302c, strength: 0.1, blend: 'normal' },
  },
});
